

import { useContext, useEffect, useState } from "react";
import { Button, Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../API/res";
import "../App.css";
import { AuthContext } from "./AuthContext";

const NavigationBar = () => {
  const { user, setUser, isAuthenticated, setIsAuthenticated, loading } = useContext(AuthContext);
  const [expanded, setExpanded] = useState(false);
  const [futureTechOpen, setFutureTechOpen] = useState(false);
  const [oracleOpen, setOracleOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".user-icon") &&
        !event.target.closest(".user-dropdown")
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
  setTimeout(() => {
    window.dispatchEvent(new Event("resize")); // Triggers layout recalculation
  }, 100); // slight delay to allow render
}, []);


  const handleNavClick = (path) => {
    setExpanded(false);
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(path);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      setUser(null);
      setIsAuthenticated(false);
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("lastActiveTime");
      localStorage.removeItem("user");
      localStorage.removeItem("isAuthenticated");
      setDropdownOpen(false);
      setExpanded(false);
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const getUserInitial = () => {
    return (
      user?.username?.charAt(0)?.toUpperCase() ||
      user?.name?.charAt(0)?.toUpperCase() ||
      user?.email?.charAt(0)?.toUpperCase() ||
      "U"
    );
  };

  if (loading) return null;

  return (
    <Navbar
      className="custom-navbar"
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          <img
            src="/images/logo.jpg"
            alt="Instil-IT Logo"
            className="navbar-logo navbar-logo-adjusted"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="ms-auto border-0 shadow-none"
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav
            className={`${
              isMobile
                ? "flex-column w-100"
                : "ms-4 me-auto align-items-start flex-lg-row"
            }`}
          >
            <Nav.Link onClick={() => handleNavClick("/")}>Home</Nav.Link>

            <NavDropdown
              title="FutureTech Training"
              id="futuretech-training-dropdown"
              show={isMobile ? futureTechOpen : undefined}
              onClick={() => isMobile && setFutureTechOpen((prev) => !prev)}
              onMouseEnter={() => !isMobile && setFutureTechOpen(true)}
              onMouseLeave={() => !isMobile && setFutureTechOpen(false)}
              className={`nav-dropdown ${isMobile ? "mobile-dropdown" : "wide-dropdown"}`}
            >
              <NavDropdown.Item as={Link} to="/coursesoffered" onClick={() => { setFutureTechOpen(false); setExpanded(false); }}>Courses</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/futuretech-training" onClick={() => { setFutureTechOpen(false); setExpanded(false); }}>FutureTech Learning Videos</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/mock-interview" onClick={() => { setFutureTechOpen(false); setExpanded(false); }}>Mock Interview</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="Products"
              id="oracle-applications-dropdown"
              show={isMobile ? oracleOpen : undefined}
              onClick={() => isMobile && setOracleOpen((prev) => !prev)}
              onMouseEnter={() => !isMobile && setOracleOpen(true)}
              onMouseLeave={() => !isMobile && setOracleOpen(false)}
              className={`nav-dropdown ${isMobile ? "mobile-dropdown" : "wide-dropdown"}`}
            >
              <NavDropdown.Item as={Link} to="/ai-talent-hub" onClick={() => { setOracleOpen(false); setExpanded(false); }}>AI Talent Hub</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/resume" onClick={() => { setOracleOpen(false); setExpanded(false); }}>Resume Builder</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/freelancer-trainer" onClick={() => setExpanded(false)}>
              Trainer Hub
            </Nav.Link>
            <Nav.Link as={Link} to="/about-us" onClick={() => setExpanded(false)}>
              About Us
            </Nav.Link>
          </Nav>

          <Nav className={`ms-auto align-items-center mt-3 mt-lg-0 ${isMobile ? "w-100 justify-content-end pe-2" : ""}`}>
            {isAuthenticated && user ? (
              <div className={`position-relative ${isMobile ? "" : "ms-3"}`} style={{ display: "flex", justifyContent: "flex-end", width: isMobile ? "100%" : "auto" }}>
                <div
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="user-icon d-flex align-items-center justify-content-center rounded-circle bg-primary text-white shadow-sm"
                  style={{ width: "44px", height: "44px", cursor: "pointer", fontWeight: "bold", fontSize: "18px" }}
                >
                  {getUserInitial()}
                </div>
                {dropdownOpen && (
                  <div
                    className="user-dropdown shadow border rounded bg-white animate__animated animate__fadeIn"
                    style={{
                      position: "absolute",
                      top: "52px",
                      right: "0",
                      zIndex: 1000,
                      width: isMobile ? "95%" : "180px",
                      maxWidth: "250px",
                      borderRadius: "12px",
                      overflow: "hidden"
                    }}
                  >
                    <Button
                      variant="link"
                      className="w-100 text-start px-4 py-3 text-dark fw-semibold border-bottom"
                      onClick={() => { setDropdownOpen(false); navigate("/profilepage"); }}
                    >
                      <i className="bi bi-person me-2"></i> Profile
                    </Button>
                    {/* <Button
                      variant="link"
                      className="w-100 text-start px-4 py-3 text-success fw-semibold border-bottom"
                      onClick={() => { setDropdownOpen(false); navigate("/refer"); }}
                    >
                      <i className="bi bi-gift me-2"></i> Refer & Earn ₹12K
                    </Button> */}
                    <Button
                      variant="link"
                      className="w-100 text-start px-4 py-3 text-danger fw-semibold"
                      onClick={handleLogout}
                    >
                      <i className="bi bi-box-arrow-right me-2"></i> Logout
                    </Button>
                  </div>
                )}
              </div>
            ) : (
              <div className={isMobile ? "w-100 d-flex justify-content-end mt-2 pe-2" : "ms-3"}>
                <Button className="Login-btn"
  variant="outline-primary"
  onClick={() => {
    setExpanded(false);
    navigate("/login");
  }}
>
  Login
</Button>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
